var rich_content_viewer_default = {
  "fontElementMap": "-epfX",
  "wrapper": "etZhO",
  "pluginContainerMobile": "oKy8S",
  "viewer": "fkLBG",
  "android": "dWeS1",
  "rootedTraversedContent": "hBQrA",
  "atomic": "_9XLi8",
  "toolbar": "acmjU",
  "block": "B-8je"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
